import { css } from '@emotion/react';
import { shouldNotForwardProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
import styled from '@emotion/styled';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
import React, { forwardRef } from 'react';
import { keyframes } from '@emotion/react';
export var SpinnerSizes;
(function (SpinnerSizes) {
    SpinnerSizes["small"] = "small";
    SpinnerSizes["medium"] = "medium";
})(SpinnerSizes || (SpinnerSizes = {}));
export var SpinnerTypes;
(function (SpinnerTypes) {
    SpinnerTypes["default"] = "default";
    SpinnerTypes["inverted"] = "inverted";
})(SpinnerTypes || (SpinnerTypes = {}));
const ANIMATION_SPEED = `3.4s`;
const Spinner = forwardRef(({ size = SpinnerSizes.small, disabled = false, type = SpinnerTypes.default, 'aria-label': ariaLabel = 'progress', ...props }, ref) => {
    const strokeSize = size === SpinnerSizes.small ? 16 : 32;
    const strokeWidth = size === SpinnerSizes.small ? 2 : 4;
    return (React.createElement(SpinnerContainer, { ...props, ref: ref },
        React.createElement(Svg, { width: `${strokeSize}px`, height: `${strokeSize}px`, viewBox: `0 0 ${strokeSize * 10} ${strokeSize * 10}`, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": ariaLabel, disabled: disabled, size: strokeSize },
            React.createElement(Circle, { type: type, size: strokeSize, isSmall: size === SpinnerSizes.small, shapeRendering: "geometricPrecision", fill: "none", strokeWidth: strokeWidth * 10, strokeLinecap: "butt", cx: Math.floor(strokeSize * 5), cy: Math.floor(strokeSize * 5), r: Math.floor((strokeSize - strokeWidth - 2) * 5) }))));
});
Spinner.displayName = 'Spinner';
export default Spinner;
const SpinnerContainer = styled.div `
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
const rotator = keyframes `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const dashConstruct = (isSmall = false) => keyframes `
  0% {
    stroke-dashoffset: 260%;
  }
  50% {
    stroke-dashoffset: ${isSmall ? 25 : 0}%;
    transform: rotate(180deg);
  }
  100% {
    stroke-dashoffset: 260%;
    transform: rotate(725deg);
  }
`;
const dash = dashConstruct();
const dashSmall = dashConstruct(true);
const Svg = styled('svg', shouldNotForwardProps(true, 'size', 'disabled'))(({ size, disabled }) => css(css `
      animation: ${rotator} ${ANIMATION_SPEED} linear infinite;
      width: ${size}px;
      height: ${size}px;
    `, disabled &&
    css `
        opacity: ${Opacities.low};
      `));
const Circle = styled('circle', shouldNotForwardProps(true, 'type', 'size', 'isSmall'))(({ theme, isSmall, size, type }) => css `
    stroke: ${type === SpinnerTypes.default ? theme.spinner.color : theme.spinner.invertedColor};
    stroke-dasharray: 260%;
    stroke-dashoffset: 0;
    transform-origin: ${Math.floor(size * 5)}px ${Math.floor(size * 5)}px;
    animation: ${isSmall ? dashSmall : dash} ${ANIMATION_SPEED} ease-in-out infinite;
  `);
